/**
 * Which creation forms a list page offers: exactly those the server declares for it, by name
 * (`FormConfig.list_pages`), never by position in `list_config.forms`.
 */

/** Name of an object's main list page (`FormConfig.list_pages`). */
export const DEFAULT_LIST_PAGE = "default";

/** Whether a creation form is offered on the list page `page` (unset: the main list page). */
export function offeredOn(form: { list_pages?: string[] | null }, page: string | undefined): boolean {
    return (form.list_pages ?? [DEFAULT_LIST_PAGE]).includes(page ?? DEFAULT_LIST_PAGE);
}
